<template>
    <aside class="sidebar">
        <div class="logo">
            <router-link class="logo-link" :to="'/'">
                <IconPlane class="logo-icon" />
            </router-link>
        </div>
        <div class="menu-items">
            <div v-for="item in items" :key="item.name">
                <router-link :to="item.route">
                    <div class="menu-item" :class="{ 'active': isActive(item.route) }">
                        <component :is="item.icon" class="icon" />
                    </div>
                </router-link>
            </div>
        </div>
        <div @click="logout" class="menu-item logout">
            <IconLogout2 class="icon" />
        </div>
    </aside>
</template>

<script>
import {
    IconPlane, // Logo
    IconMessage,
    IconInfoCircle,
    IconTicket,
    IconCar,
    IconBriefcase,
    IconLogout2
} from '@tabler/icons-vue';

export default {
    name: 'SidebarComponent',
    components: {
        IconPlane,
        IconMessage,
        IconInfoCircle,
        IconTicket,
        IconCar,
        IconBriefcase,
        IconLogout2
    },
    data() {
        return {
            items: [
                {
                    name: 'Home',
                    route: '/',
                    icon: 'IconMessage'
                },
                {
                    name: 'About',
                    route: '/about',
                    icon: 'IconInfoCircle'
                },
                {
                    name: 'Tickets',
                    route: '/tickets',
                    icon: 'IconTicket'
                },
                {
                    name: 'Go',
                    route: '/go',
                    icon: 'IconCar'
                }


            ]
        }
    },

    methods: {
        isActive(route) {
            return this.$route.path === route;
        },

        async logout() {
            // Implement logout logic here
            let ask = confirm('Are you sure you want to sign-out?');

            if (ask) {
                try {
                    await this.$api.logout();
                    this.$router.push({ name: 'Login' });
                } catch (err) {
                    this.error = err.message || 'Logout failed';
                }
            }
        }
    }
}
</script>

<style scoped>
.icon {
    width: 24px;
    height: 24px;
    margin-top: 14px;
    color: var(--color-icon);
}

.sidebar {
    background-color: var(--color-secondary);
    border-right: 1px solid var(--color-border);
    height: 100vh;
    width: 80px;
    min-width: 65px;
    z-index: 99999;
}

.menu-item.active .icon {
    color: var(--color-primary);
}

.menu-item.active,
.menu-item:hover {
    background-color: var(--color-hover);
}

.menu-item {
    width: 48px;
    height: 48px;
    text-align: center;
    margin: 12px auto;
    border-radius: var(--default-border-radius);
}

.menu-items {
    padding-top: 20px;
}

.logo {
    text-align: center;
    padding-top: 30px;
}

.logo-link {
    width: 48px;
}

.logo-icon {
    width: 32px;
    height: 32px;
    color: var(--color-primary);
}

.logout {
    position: absolute;
    bottom: 20px;
    left: 9px;
    cursor: pointer;
}
</style>